import { Trash2 } from "lucide-react";

export default function AdminStudio({ ctx }) {
  const { studio, delStudioBooking } = ctx;
  return (
    <div className="mt-10 space-y-2">
      {studio.length === 0 ? <p className="text-stone-500">No studio bookings yet.</p> :
        studio.map((s) => (
          <div key={s.id} data-testid={`studio-booking-${s.id}`} className="p-4 bg-white border border-stone-200 rounded-xl flex justify-between gap-4 flex-wrap">
            <div>
              <p className="font-medium text-stone-900">{s.user_name} · {s.user_email}</p>
              <p className="text-sm text-stone-500">{s.booking_date} · {s.time_slot} · {s.expected_attendees} attendees</p>
              <p className="text-sm text-stone-600 mt-1 italic">{s.purpose}</p>
            </div>
            <div className="flex items-center gap-2 h-fit">
              <span className={`px-3 py-1 rounded-none text-xs ${
                s.status === "paid" ? "bg-emerald-100 text-emerald-800" :
                s.status === "pending_payment" ? "bg-amber-100 text-amber-800" :
                "bg-stone-100 text-stone-700"
              }`}>{s.status.replace(/_/g, " ")}</span>
              <button
                data-testid={`delete-studio-booking-${s.id}`}
                onClick={() => delStudioBooking(s.id)}
                title="Delete booking"
                className="p-2 text-stone-400 hover:text-red-500"
              >
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        ))}
    </div>
  );
}
